import { declareVueComponent } from "/vodalys/vvuejs";

declareVueComponent('PlanDuration', () => import('./components/PlanDuration.vue'));

